<div class="col-auto voiceResponse-block" [class.active]="openChatBox">
    <!-- @if (openChatBox){
        <div class="chat-close">
            <img src="/assets/images/close.svg" alt="Close" (click)="closeChatPop();">
        </div>
    } -->
    <div class="responseBlock" #scrollContainer>
        @if (showLoadMoreBtn && !chatLoading && !loadingMoreHistory) {
        <div class="load-more-btn-wrap">
            <a href="javascript:void(0)" (click)="loadingMoreChat()">
                <span>
                    <img src="assets/images/common/refresh_green.svg" alt="">
                    {{'LoadOlderChats' | translate}}
                </span>
            </a>
        </div>
        }
        @if(loadingMoreHistory){
        @for (item of [1,2,3]; track $index) {
        <div class="chat-loader">
            <div class="l-question">
                <span class="loadingItem">
                    <i>Hey, hello, how are you?</i>
                </span>
            </div>
            <div class="l-answer">
                <span class="loadingItem me-3">
                    <i>ssss</i>
                </span>
                <span class="loadingItem">
                    <i>Hello, Sandy! I'm doing well, thank you for asking.</i>
                </span>
            </div>
        </div>
        }
        }

        @for(message of loopMessages; track $index) {
        <!-- @if (message.separation) {
                @switch (message.separation) {
                    @case('rules') {
                        <div class="chat-line">
                            <img src="/assets/images/rule-chat-icon.svg" alt="Golf">
                        </div>
                    }
                    @case ('general') {
                        <div class="chat-line general"></div>
                    }
                    @case ('search_area_tee_times') {
                        <div class="chat-line">
                            <img src="/assets/images/tee-times.svg" alt="Golf">
                        </div>
                    }
                }
            } -->
        <div class="response_row d-flex align-items-center justify-content-end mb-3">
            @if (!message.showProcessingText){
            <div class="color_box">
                {{message.question}}
            </div>
            }
        </div>
        <div class="response_row d-flex mb-3">
            <!-- @if (!message.loading) {
                    <div class="avatar w-100">
                        <img src="/assets/images/logoIcon.svg" alt="Golf">
                    </div>
                } -->

            <div class="answerBlck__contArea">
                @if (!message.loading) {
                @if (message.isBlocks){
                <app-block-elements [loading]="message.answerProcessing"
                    [contentBlocks]="message.contentBlocks"></app-block-elements>
                } @else {
                <div [innerHTML]="message.answer | formatChat"></div>
                }
                @if(message.sources && message.sources.length > 0) {
                <source-block class="mt-2" [sources]="message.sources"
                    (openSourceModal)="openSourcePanel(message.sources)"></source-block>
                }
                <div class="col">
                    <div class="actionBlock mt-2">
                        <li (click)="addReaction('dislike', $index, message.answerId)">
                            @if (message.reaction === 'dislike'){
                            <img src="/assets/images/disliked.svg" alt="Dislike">
                            } @else {
                            <img src="/assets/images/dislike.svg" alt="Dislike">
                            }
                        </li>
                        <li (click)="addReaction('like', $index, message.answerId)">
                            @if (message.reaction === 'like'){
                            <img src="/assets/images/liked.svg" alt="Like">
                            } @else {
                            <img src="/assets/images/like.svg" alt="Like">
                            }
                        </li>
                        <li>
                            <a class="cursor-pointer"
                                (click)="!message.listening && !answerListening ? hearAnswer(message.answer, $index) : message.listening ? stopListening($index): ''">
                                @if (audioAnswerLoading && message.loadingAudio){
                                <img src="assets/images/send-loader.svg" alt="">
                                } @else {
                                @if(message.listening){
                                <img src="assets/images/stop.svg" alt="" class="stop">
                                } @else {
                                <img src="/assets/images/sound.svg" alt="">
                                }
                                }
                            </a>
                        </li>
                    </div>
                </div>
                <div class="route-block">
                    @if(message.route === 'rules'){
                    <span>Ask a real rules official</span>
                    <a href="javascript:void(0)" (click)="openRuleAssistModal(ruleAssistModal, $index)">
                        <img src="assets/images/ask-blakey-icon.svg" alt="">
                        {{'Ask Blakey' | translate}}
                    </a>
                    }
                </div>
                } @else {
                <div class="letsTalk_block processing">
                    <img src="/assets/images/chat-animation.gif" alt="processing">
                    @if (message.showProcessingText){
                    {{message.question}}
                    }
                </div>
                }

            </div>
        </div>
        }
        <!-- letsTalk_block -->

    </div>
    <div class="voice-block bg-white" [class.disabled]="answerProcessing">
        @if(recordingFinished){
        <div class="audio-wrap">
            <audio #audioRef [src]="audioUrl" (pause)="onPauseOrEnd()" (ended)="onPauseOrEnd()"
                (play)="onAudioPlay()"></audio>
            <!-- @if(!isAudioPlaying) {
                    <button [disabled]="!recordingFinished || !audioUrl" (click)="onPlay()" class="btn bg-white play-btn">
                        <img src="/assets/images/play.svg" alt="Play">
                    </button>
                } @else {
                    <button [disabled]="!recordingFinished || !audioUrl" (click)="onPause()" class="btn bg-white play-btn">
                        <img src="/assets/images/pause.svg" alt="Pause">
                    </button>
                } -->
        </div>
        }

        @if (!hideLoadingText && !submittingAudio){
            <button class="letsTalk_block none-loading" (click)="showInputBox()">
                <div class="d-flex">
                    Let's talk
                    <div class="inline-block word-carousel">
                        <span>tee times</span>
                        <span>golf rules</span>
                        <span>golf news</span>
                        <span>golf yardage</span>
                    </div>
                </div>
            </button>
        }


        <div class="equalizer-box" [class.active]="showEqualizer">
            <canvas #equalizerCanvas width="330" height="70"></canvas>
        </div>
        @if (hideLoadingText){
        <div class="chat-text-block">
            <textarea #chatTextarea name="chatPrompt" [disabled]="answerProcessing" [(ngModel)]="chatPrompt"
                (input)="autoResize($event)" (keydown.enter)="getChatResponse()" (focus)="setOpenChatBox()"
                (blur)="hideProcessingText()" placeholder="Ask anything about golf"></textarea>
        </div>
        }


        <div class="d-inline-flex align-items-center">
            @if (isRecording) {
            <button (click)="closeRecording()" class="btn bg-white p-0 ms-2">
                <img src="/assets/images/close.svg" alt="Stop">
            </button>
            <button (click)="stopRecording()" class="btn bg-white p-0 ms-2">
                <img src="/assets/images/tick-thin.svg" alt="Close">
            </button>
            } @else if (submittingAudio) {
            <button class="btn bg-white p-0 ms-2">
                <img src="/assets/images/spinner.svg" alt="Close" class="spinning-animation">
            </button>
            } @else {
            <button (click)="!isSignedIn ? nonLoggedInToaster() : startRecording()" class="btn bg-white p-0 ms-2">
                <img src="/assets/images/microphone-voice.svg" alt="Microphone">
            </button>
            }

            @if (((this.chatPrompt || this.audioBlob) || answerProcessing) && !isRecording && !this.submittingAudio){
            <button class="btn bg-dark p-0 ms-2 border-0 cursor-pointer" [disabled]="answerProcessing"
                (click)="!answerProcessing ? getChatResponse() : ''">
                <img src="/assets/images/upArw-voice.svg" alt="Enter">
            </button>
            }
            <!-- @else {
                <button class="btn bg-dark p-0 ms-2 border-0 cursor-pointer">
                    <img src="assets/images/white-loader.svg" alt="">
                </button>
            } -->

            @if(!answerProcessing && !isRecording && !this.chatPrompt && !this.audioBlob && !this.submittingAudio) {
            <button class="btn bg-dark p-0 ms-2 border-0 cursor-pointer"
                (click)="!isSignedIn ? nonLoggedInToaster() : ''" [routerLink]="['/voice-liv']">
                <img src="/assets/images/voiceIcon.svg" alt="Use voice mode">
            </button>
            }
        </div>
    </div>
</div>

<!-- sourcePanelBg -->
<div class="sourcePanelBg w-100" [class.active]="showSourceModal">
    <source-modal [sources]="selectedSources" (closePanel)="showSourceModal = false;"></source-modal>
</div>
<!-- sourcePanelBg -->

<ng-template #ruleAssistModal>
    <app-rule-assist-modal [ruleAssistQuestionObject]="ruleAssistQuestionObject"
        (closeModal)="closeRuleAssistModal()"></app-rule-assist-modal>
</ng-template>